let setupPopHandler = null;

// Native Back must be intercepted before BrowserRouter's own popstate listener
// can change the route and unmount the editor. The handler is active only while
// a mounted service setup has unsaved changes.
if (typeof window !== "undefined") {
  window.addEventListener("popstate", event => setupPopHandler?.(event), true);
}

export function registerSetupPopHandler(handler) {
  setupPopHandler = handler;
  return () => { if (setupPopHandler === handler) setupPopHandler = null; };
}
